import { isToggleElement, userTitle } from './elements';
import { validateInput } from './validate';
import { controllers } from '../../controllers/controller';
import { resetValue } from '../../shared/localstorage';
var inputForms = ['password', 'email', 'text'];
var addInput = function (type) {
    if (type === void 0) { type = 'text'; }
    var container = document.createElement('div');
    var input = document.createElement('input');
    var hint = document.createElement('p');
    container.className = 'login-input-container';
    hint.className = 'login-input-hint';
    switch (type) {
        case 'text':
            input.type = type;
            input.name = 'username';
            input.id = 'username-field';
            input.className = 'login-form-field';
            input.placeholder = 'username';
            hint.textContent = 'Имя может содержать только цифробуквенные символы и не менее 3 символов';
            break;
        case 'email':
            input.type = type;
            input.name = type;
            input.id = "".concat(type, "-field");
            input.className = 'login-form-field';
            input.placeholder = "".concat(type);
            hint.textContent = 'Почта может содержать только цифробуквенные символы';
            break;
        case 'password':
            input.type = type;
            input.name = type;
            input.id = "".concat(type, "-field");
            input.className = 'login-form-field';
            input.placeholder = "".concat(type);
            hint.textContent =
                'Пароль может содержать только цифробуквенные символы и не менее 8 символов';
            break;
        default:
            break;
    }
    input.addEventListener('input', function (e) {
        var isValidate = validateInput(type, input.value);
        if (isValidate) {
            if (!container.classList.contains('validate'))
                container.classList.add('validate');
            if (container.classList.contains('invalidate'))
                container.classList.remove('invalidate');
        }
        else {
            if (container.classList.contains('validate'))
                container.classList.remove('validate');
            if (!container.classList.contains('invalidate'))
                container.classList.add('invalidate');
        }
    });
    container.append(input);
    container.insertAdjacentElement('afterbegin', hint);
    return container;
};
var renderUserForm = function () {
    var signin = controllers.signin;
    var textMessageHolder = signin ? 'Если вы не регистрировались' : 'Если у вас уже есть аккаунт ';
    var messageHolder = document.querySelector('#user-sign-msg');
    var messageButtonSwtchAuth = document.querySelector('#user-sign-button');
    var buttonSubmit = document.querySelector('#login-form-submit');
    var form = document.querySelector('form');
    var blocksInputForm = form.querySelectorAll('div');
    messageHolder.textContent = textMessageHolder;
    messageButtonSwtchAuth.textContent = signin ? 'регистрация' : 'авторизация';
    buttonSubmit.value = signin ? 'Авторизация' : 'Регистрация';
    blocksInputForm.forEach(function (element) {
        element.parentNode.removeChild(element);
    });
    inputForms.forEach(function (element, index) {
        if (signin) {
            if (index < 2)
                form.insertAdjacentElement('afterbegin', addInput(element));
        }
        else {
            form.insertAdjacentElement('afterbegin', addInput(element));
        }
    });
};
var addUserForm = function () {
    var currentSignin = controllers.signin;
    var fragment = document.createDocumentFragment();
    var messageHolder = document.createElement('div');
    var messageButtonSwtchAuth = document.createElement('button');
    var form = document.createElement('form');
    var buttonReset = document.createElement('button');
    var buttonUserLogout = document.createElement('button');
    var buttonSubmit = document.createElement('input');
    messageHolder.id = 'user-sign-msg-holder';
    messageButtonSwtchAuth.className = 'button button-link';
    messageButtonSwtchAuth.id = 'user-sign-button';
    messageHolder.innerHTML = "<p id=\"user-sign-msg\"></p>";
    messageHolder.append(messageButtonSwtchAuth);
    form.id = 'signin-form';
    buttonReset.type = 'reset';
    buttonReset.textContent = 'Закрыть';
    buttonSubmit.type = 'submit';
    buttonSubmit.id = 'login-form-submit';
    buttonUserLogout.type = 'button';
    buttonUserLogout.textContent = 'Выход';
    buttonUserLogout.className = 'button button-user-logout';
    form.addEventListener('submit', function (e) {
        e.preventDefault();
        var result = [];
        var isValidate = 0;
        var containersInput = document.querySelectorAll('.login-input-container');
        containersInput.forEach(function (element) {
            if (!element.classList.contains('validate')) {
                isValidate += 1;
            }
            else {
                var text = element.querySelector('input').value;
                result.push(text);
            }
        });
        if (isValidate === 0) {
            controllers.userSign(result);
        }
    });
    messageButtonSwtchAuth.addEventListener('click', function () {
        currentSignin = !currentSignin;
        controllers.signin = currentSignin;
        renderUserForm();
    });
    buttonReset.addEventListener('click', function () {
        isToggleElement('.user-handler');
    });
    buttonUserLogout.addEventListener('click', function () {
        resetValue();
        resetValue('dictionary');
        controllers.updateUser();
        isToggleElement('.user-handler');
    });
    form.append(buttonSubmit);
    fragment.append(userTitle(), userTitle('Выход'), messageHolder, form, buttonUserLogout, buttonReset);
    return fragment;
};
export { addUserForm, renderUserForm };
